import {
  selectBrand,
  selectContentSection,
  selectCustomer,
  selectCustomerRewards,
  selectCustomerTpls,
  selectTheme,
  useAppSelector,
} from '@open-tender/cloud'
import Welcome from 'components/Welcome'
import { isMobile } from 'react-device-detect'
import {
  AccountRewardsCardsContainer,
  AccountRewardsNavigationIcon,
  AccountWelcomeBackBox,
  AccountWelcomeBackGreeting,
  AccountWelcomeBackNameText,
  AccountWelcomeBackText,
  AccountWelcomeView,
  AccountWelcomeButton,
  AccountWelcomeButtonNavigationIcon,
} from './AccountWelcome.styled'
import Button from 'components/Button'
import Heading from 'components/Heading'
import Body from 'components/Body'
import { useNavigate } from 'react-router-dom'
import { ArrowUpRightSquareSolid } from 'iconoir-react'
import { usePointsShop, useTplsPointsShop } from 'hooks'

interface AccountWelcomeProps {
  greeting: string
}

const AccountWelcome = ({ greeting }: AccountWelcomeProps) => {
  const navigate = useNavigate()
  const { profile } = useAppSelector(selectCustomer)
  const { tpls } = useAppSelector(selectCustomerTpls)
  const { loyalty } = useAppSelector(selectTheme) || {}
  const loyaltyAccountWidget = loyalty?.accountWidget.type
  const firstName = profile ? profile.first_name : null
  const lastName = profile ? profile.last_name : null
  const { title, subtitle } =
    useAppSelector(selectContentSection('account')) || {}
  const { tpls: tplsType } = useAppSelector(selectBrand) || {}
  const hasTplPointsShop =
    tplsType === 'COMO' || tplsType === 'PUNCHH' || tplsType === 'SPARKFLY'
  const usePointsShopHook = hasTplPointsShop ? useTplsPointsShop : usePointsShop
  const { pointsBalance } = usePointsShopHook()
  const { entities: rewards } = useAppSelector(selectCustomerRewards)
  const showLoyaltyAccountWidget = loyaltyAccountWidget === 'WELCOME_BACK'
  const hasPointsShop = tpls || pointsBalance
  const rewardsNumber = tpls ? tpls.rewards.length : rewards.length

  return showLoyaltyAccountWidget ? (
    <AccountWelcomeView>
      <Welcome title={title} />
      <AccountWelcomeBackGreeting>
        {hasPointsShop ? (
          <AccountWelcomeBackBox>
            <AccountWelcomeBackText>
              {subtitle}{' '}
              <AccountWelcomeBackNameText>
                {firstName}!
              </AccountWelcomeBackNameText>
            </AccountWelcomeBackText>
            <AccountRewardsCardsContainer>
              <Button onClick={() => navigate('/points-shop')}>
                <AccountRewardsNavigationIcon>
                  <ArrowUpRightSquareSolid height={20} width={20} />
                </AccountRewardsNavigationIcon>
                <Heading size="big">{pointsBalance}</Heading>
                <Body size="main">My Points</Body>
              </Button>
              <Button onClick={() => navigate('/rewards')} color="secondary">
                <AccountRewardsNavigationIcon>
                  <ArrowUpRightSquareSolid height={20} width={20} />
                </AccountRewardsNavigationIcon>
                <Heading size="big">{rewardsNumber}</Heading>
                <Body size="main">My Rewards</Body>
              </Button>
            </AccountRewardsCardsContainer>
          </AccountWelcomeBackBox>
        ) : (
          <AccountWelcomeBackBox>
            <AccountWelcomeBackText>
              {subtitle}{' '}
              <AccountWelcomeBackNameText>
                {firstName} {lastName}
              </AccountWelcomeBackNameText>
            </AccountWelcomeBackText>
            <AccountRewardsCardsContainer>
              <Button onClick={() => navigate('/signup')} color="secondary">
                <AccountRewardsNavigationIcon>
                  <ArrowUpRightSquareSolid height={20} width={20} />
                </AccountRewardsNavigationIcon>
                <Heading size="big">Sign Up For An Account</Heading>
              </Button>
            </AccountRewardsCardsContainer>
          </AccountWelcomeBackBox>
        )}
        <AccountWelcomeButton>
          <Button onClick={() => navigate('/order-type')}>
            <AccountWelcomeButtonNavigationIcon />
            Order Now
          </Button>
        </AccountWelcomeButton>
      </AccountWelcomeBackGreeting>
    </AccountWelcomeView>
  ) : (
    <Welcome title={greeting} subtitle={!isMobile ? subtitle : undefined} />
  )
}

export default AccountWelcome
